import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0a0a0a]';
  const variants = {
    primary: 'bg-[#ff6b35] text-white hover:bg-[#e55a2b] focus:ring-[#ff6b35]',
    ghost: 'bg-transparent text-[#f5f5f5] border border-[#333] hover:border-[#ff6b35] hover:text-[#ff6b35] focus:ring-[#ff6b35]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-195">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-4 h-4" data-id="element-196" />}
    </motion.button>;
}